import React from 'react'
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { CalendarIcon } from '../Layout/Svg';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

function ButtonField(props) {
  const {
    setOpen,
    label,
    id,
    disabled,
    InputProps: { ref } = {},
    inputProps: { 'aria-label': ariaLabel } = {},
  } = props;

  return (
    <Button
      sx={{
        height: '40px',
        color: '#374151',
        backgroundColor: '#fff',
        border: '1px solid #E0E0E0',
        borderRadius: '8px',
        padding: '8px 16px',
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 500,
        minWidth: '200px',
        justifyContent: 'space-between',
        '&:hover': {
          backgroundColor: '#F9FAFB',
          borderColor: '#BF1D2D',
        },
        '&:disabled': {
          backgroundColor: '#F3F4F6',
          color: '#9CA3AF',
        }
      }}
      variant="outlined"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CalendarTodayIcon sx={{ fontSize: 18, color: '#6B7280' }} />
        <span>{label || 'Pick a date'}</span>
      </Box>
    </Button>
  );
}

export default function ButtonDatePickerNew(props) {
  const [open, setOpen] = React.useState(false);

  return (
    <DatePicker
      slots={{ field: ButtonField, ...props.slots }}
      slotProps={{ 
        field: { setOpen },
        popper: {
          sx: {
            '& .MuiPaper-root': {
              borderRadius: '12px',
              boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
              marginTop: '8px',
            }
          }
        }
      }}
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}